import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// 全局引入 Vant 组件库
import Vant from "vant";
// 引入 Vant 样式
import "vant/lib/index.css";

// 1. 引入 dayjs
import dayjs from "dayjs";

// 2. 【可选】设置中文语言（默认英文）
import "dayjs/locale/zh-cn";
dayjs.locale("zh-cn");

// 3. 【可选】加载插件（例如 relativeTime 显示“刚刚”、“3天前”等）
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);

// 4. 挂载到 Vue 原型，所有组件可通过 this.$dayjs 使用
Vue.prototype.$dayjs = dayjs;
Vue.config.productionTip = false;
// 全局忽略 vue-router 的 unhandled rejection
import VueRouter from "vue-router";
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => {
    // 忽略 NavigationDuplicated 等错误
    if (err.name !== "NavigationDuplicated") {
      console.warn("Router push error:", err);
    }
  });
};
// 引入电子签名
import vueEsign from "vue-esign";
//测试与开发环境打开vconsole
// if (import.meta.env.VITE_APP_ENV === 'test' || import.meta.env.VITE_APP_ENV === 'development') {
if (process.env.VUE_APP_ENABLE_VCONSOLE == "true") {
  import("vconsole").then((vConsole) => {
    new vConsole.default();
  });
}
// 使用电子签名
Vue.use(vueEsign);
// 安装 Vant 插件
Vue.use(Vant);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
